// extracted by mini-css-extract-plugin
var _1 = "ra-urgent-message-close";
var _2 = "ra-urgent-message";
var _3 = "ra-urgent-message-content";
var _4 = "ra-urgent-message-highlight";
export { _1 as "urgentMessageCloseCls", _2 as "urgentMessageCls", _3 as "urgentMessageContentCls", _4 as "urgentMessageHighlightCls" }
